import { Query } from 'acast-reactor';
import request from 'superagent';
import { getUserToken } from 'services/authentication';
import Config from 'app/config';

export default Query.define('episode/read', {
  cache: false,

  execute: id =>
    new Promise((resolve, reject) => {
      const API_HOST = Config.get('CREATE_API_HOST');

      request
        .get(`${API_HOST}/api-v2/acasts/${id}`)
        .set('Authorization', `Bearer ${getUserToken()}`)
        .end((err, res) => {
          if (err) {
            return reject(err);
          }
          return resolve(res.body);
        });
    }),
});
